export default "__VITE_ASSET__BOpvrd87__"